import { SimpleGrid } from "@mantine/core";
import { HeldEmailStats } from "../../../services/admin/systemEmails.service";
import { HeldEmailStatCard } from "./HeldEmailStatCard";

interface HeldEmailStatsCardsProps {
  stats: HeldEmailStats;
}

export function HeldEmailStatsCards({ stats }: HeldEmailStatsCardsProps) {
  return (
    <SimpleGrid cols={{ base: 2, sm: 4 }}>
      <HeldEmailStatCard label="Waiting for review" value={stats.pending} />
      <HeldEmailStatCard label="Blocked" value={stats.blocked} />
      <HeldEmailStatCard label="Release failed" value={stats.failed} />
      <HeldEmailStatCard label="All captured" value={stats.total} />
    </SimpleGrid>
  );
}
